export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-5">
              <i className="ri-fire-fill text-base"></i>
              <span>全网吃瓜第一站</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              黑料网下载
              <span className="block text-primary-500 mt-1">全网黑料视频在线观看平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 font-medium mb-4">
              新鲜热辣 · 持续更新 · 即点即看
            </p>

            <div className="max-w-xl mx-auto lg:mx-0">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                黑料网下载汇聚全网最新最全的黑料视频在线观看资源，覆盖<strong>黑料网在线观看</strong>、<strong>黑料在线观看</strong>等热门频道。无需下载安装，打开即看，高清流畅。每日更新最新吃瓜内容、独家爆料和热点追踪，致力于成为用户首选的<strong>黑料视频在线播放</strong>平台。无论是最新娱乐圈动态、社会热点事件深度挖掘，还是各种独家内幕消息，都能在这里第一时间掌握。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                本站内容由专业编辑团队筛选整理，确保每一段黑料视频在线观看资源真实可靠。支持多设备观看，手机电脑随心切换，让<strong>黑料在线看片</strong>更便捷。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">10万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">全网视频资源</div>
              </div>
              <div className="w-px h-10 bg-secondary-200 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">内容持续追踪</div>
              </div>
              <div className="w-px h-10 bg-secondary-200 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-800 font-heading">安全稳定</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">无需下载安装</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观看视频
              </a>
              <a
                href="#cards"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg border-2 border-secondary-300 text-foreground-700 font-semibold text-sm md:text-base hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-eye-line text-lg"></i>
                浏览最新黑料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-secondary-100 aspect-[4/3] lg:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20abstract%20composition%20with%20warm%20crimson%20red%20and%20deep%20amber%20gradients%2C%20dark%20silhouette%20shapes%2C%20cinematic%20lighting%20with%20lens%20flare%20effects%2C%20mysterious%20atmosphere%2C%20modern%20digital%20art%20style%2C%20high%20contrast%2C%20editorial%20quality%2C%20clean%20composition%2C%20subtle%20geometric%20patterns%20in%20background%2C%20professional%20color%20grading%20with%20warm%20tones&width=960&height=720&seq=hero-main-2026-x1&orientation=landscape"
                alt="黑料网下载 - 全网黑料视频在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2 text-background-50 text-xs md:text-sm">
                  <span className="flex items-center gap-1 bg-black/40 backdrop-blur-sm rounded-full px-3 py-1">
                    <i className="ri-eye-line"></i>
                    实时更新中
                  </span>
                  <span className="flex items-center gap-1 bg-black/40 backdrop-blur-sm rounded-full px-3 py-1">
                    <i className="ri-vidicon-line"></i>
                    高清画质
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}